module.exports = __webpack_public_path__ + "ATS/img/icon_author.2332814e.svg";